import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { SecondaryBtn } from "./CustomBtn";
import { Check, Close } from "@mui/icons-material";
import { Navigate, useNavigate } from "react-router-dom";

const FormHeadingWithBtns = ({
  title,
  btnText,
  onClick,
  isFreshlyRegistered,
}) => {
  const navigate = useNavigate();
  const mediumScreen = useMediaQuery("(max-width:960px)");

  return (
    <Stack
      direction={mediumScreen ? "column" : "row"}
      sx={{
        justifyContent: mediumScreen ? "center" : "space-between",
      }}
    >
      <Typography
        sx={{
          fontSize: "32px",
          fontFamily: "Inter-Bold",
          color: colors.textColor,
        }}
      >
        {title}
      </Typography>

      <Stack
        direction={"row"}
        sx={{
          gap: 1,
          alignItems: "center",
          width: mediumScreen ? "100%" : "50%",
          justifyContent: "flex-end",
          mt: mediumScreen ? 2 : 0,
        }}
      >
        {/* <Box
          sx={{
            width: mediumScreen ? "30%" : "20%",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              textDecorationLine: "underline",
              color: colors.primary,
              fontFamily: "Inter-SemiBold",
            }}
          >
            Save as draft
          </Typography>
        </Box> */}
        {!isFreshlyRegistered && (
          <SecondaryBtn
            text={"Cancel"}
            Icon={Close}
            width={mediumScreen ? "35%" : "20%"}
            noMb
            noMt
            black
            onClick={() => navigate(-1)}
          />
        )}
        <SecondaryBtn
          text={btnText}
          Icon={Check}
          width={mediumScreen ? "35%" : "20%"}
          noMb
          noMt
          filled
          onClick={onClick}
        />
      </Stack>
    </Stack>
  );
};

export default FormHeadingWithBtns;
